import React from 'react';
import { useSelector } from 'react-redux';
import i18n from '~shared/utils/i18n';
import Blurb from '~shared/ui/Blurb';
import {
    MADE_FOR_YOU_FOR_TODAY_TYPE,
    I18N_MADE_FOR_YOU_LOGIN_TO_SEE_TEXT,
    I18N_MADE_FOR_YOU_BLURB_MAP,
} from '~scenes/madeforyou/constants';
import {
    selectActiveTab,
    selectTabIsLoading,
    selectIsMadeForYouWidget,
} from '~scenes/madeforyou/app/selectors/mfySelectors';
import BetCards from '../elements/BetCards';
import Footer from '../elements/Footer';
import NotLoggedIn from '~shared/components/not-logged-in/NotLoggedIn';
import Loading from '~shared/components/react/LoadingIndicator';
import {
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';

/**
 * Renders the tabs' content for the Made for you page.
 * @param {Object} props The props object
 * @returns {React.Element} TabsContent
 */
const TabsContent = () => {
    const isLoggedIn = useIsUserLoggedIn();
    const activeTab = useSelector(selectActiveTab);
    const isLoading = useSelector(selectTabIsLoading);
    const isWidget = useSelector(selectIsMadeForYouWidget);

    return (
        <>
            <Blurb
                modifiers={['solid-bg']}
                text={i18n.t(I18N_MADE_FOR_YOU_BLURB_MAP[activeTab])}
            />
            {
                !isLoggedIn && (activeTab !== MADE_FOR_YOU_FOR_TODAY_TYPE)
                ? <NotLoggedIn textKey={I18N_MADE_FOR_YOU_LOGIN_TO_SEE_TEXT} />
                : <>
                    { isLoading && <Loading className='made-for-you__loading' /> }
                    <BetCards />
                    { isWidget && <Footer /> }
                </>
            }
        </>
    );
};

export default TabsContent;
